import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultRequestDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { OperationalPlansToNotifyDto } from '../../operational/dtos/operational-plan/models';

@Injectable({
  providedIn: 'root',
})
export class OperationalPlanService {
  private restService = inject(RestService);
  apiName = 'Orchestrator';
  

  getByType = (input: PagedResultRequestDto, version: number, planTypeId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OperationalPlansToNotifyDto>({
      method: 'GET',
      url: `/api/Controlling/OperationalPlan/PlanType/${planTypeId}`,
      params: { skipCount: input.skipCount, maxResultCount: input.maxResultCount, version },
    },
    { apiName: this.apiName,...config });
}